import { render, staticRenderFns } from "./InternalMenusList.vue?vue&type=template&id=86fa85a2"
import script from "./InternalMenusList.vue?vue&type=script&lang=js"
export * from "./InternalMenusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports